// client/src/api/promotionsApi.js
//
// Promocion Educacentro - cliente API del panel comercial.
//   GET  /admin/promotions               -> listado
//   POST /admin/promotions               -> crear + enviar correo oferta
//   POST /admin/promotions/:id/reminder  -> correo de enganche manual
//   POST /admin/promotions/:id/cancel    -> cancelar codigo
// Mismo patron que leadsApi/dripApi (fetch nativo + Bearer + ENV.BASE_API).

import { ENV } from "../Utils";

async function doFetch(url, params = {}) {
  const res = await fetch(url, params);
  const ct = res.headers.get("content-type") || "";
  const parse = ct.includes("application/json")
    ? () => res.json()
    : () => res.text();
  const data = await parse().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.message || `Request error ${res.status}`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

const authHeaders = (token) =>
  token ? { Authorization: `Bearer ${token}` } : {};

export class PromotionsApi {
  /** @returns {Promise<{data:{items:Array}}>} */
  list(accessToken) {
    return doFetch(`${ENV.BASE_API}/admin/promotions`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  /**
   * Comprobacion de cortesia: dice si ese email nos consta de algo (lead,
   * usuario, cliente Stripe, promo anterior). Orientativa, no bloquea.
   * @returns {Promise<{data:{known:boolean, sources:string[]}}>}
   */
  checkEmail(accessToken, email) {
    const qs = new URLSearchParams({ email }).toString();
    return doFetch(`${ENV.BASE_API}/admin/promotions/email-check?${qs}`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  /**
   * @param {object} payload - { name, email, discount_pct, duration_days, plan_key }
   * @returns {Promise<{data:{promotion, emailSent}}>}
   */
  create(accessToken, payload) {
    return doFetch(`${ENV.BASE_API}/admin/promotions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...authHeaders(accessToken),
      },
      body: JSON.stringify(payload),
    });
  }

  sendReminder(accessToken, id) {
    return doFetch(`${ENV.BASE_API}/admin/promotions/${id}/reminder`, {
      method: "POST",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  cancel(accessToken, id) {
    return doFetch(`${ENV.BASE_API}/admin/promotions/${id}/cancel`, {
      method: "POST",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  // --- Campanas por lotes -------------------------------------------------

  /** Semaforo de envio: cuota, rebotes y si se puede enviar. */
  sesHealth(accessToken) {
    return doFetch(`${ENV.BASE_API}/admin/ses-health`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  listCampaigns(accessToken) {
    return doFetch(`${ENV.BASE_API}/admin/promo-campaigns`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  getCampaign(accessToken, id, status) {
    const qs = status ? `?${new URLSearchParams({ status })}` : "";
    return doFetch(`${ENV.BASE_API}/admin/promo-campaigns/${id}${qs}`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  /** Acciones: start | pause | abort | run */
  campaignAction(accessToken, id, action, body) {
    return doFetch(`${ENV.BASE_API}/admin/promo-campaigns/${id}/${action}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...authHeaders(accessToken),
      },
      body: JSON.stringify(body || {}),
    });
  }
}

export const promotionsApi = new PromotionsApi();
